var _ellipse, _ellipse2, _ellipse3, _ellipse4, _ellipse5, _ellipse6, _ellipse7, _ellipse8, _ellipse9, _ellipse10, _ellipse11, _ellipse12, _ellipse13, _ellipse14, _ellipse15, _ellipse16, _ellipse17, _ellipse18, _ellipse19, _ellipse20, _ellipse21, _ellipse22, _ellipse23, _ellipse24, _ellipse25, _ellipse26, _ellipse27, _ellipse28, _ellipse29, _ellipse30, _ellipse31, _ellipse32, _ellipse33, _ellipse34, _ellipse35, _ellipse36, _ellipse37, _ellipse38, _ellipse39, _ellipse40, _ellipse41, _ellipse42, _ellipse43, _ellipse44, _ellipse45, _ellipse46, _ellipse47, _ellipse48, _ellipse49, _ellipse50, _ellipse51, _ellipse52, _ellipse53, _ellipse54, _ellipse55, _ellipse56, _ellipse57, _ellipse58, _ellipse59, _ellipse60, _ellipse61, _ellipse62, _ellipse63, _ellipse64, _ellipse65, _ellipse66, _ellipse67, _ellipse68, _ellipse69, _ellipse70, _ellipse71, _ellipse72, _ellipse73, _ellipse74, _ellipse75, _ellipse76, _ellipse77, _ellipse78, _ellipse79, _ellipse80;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDotsRightDown(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 82,
    height: 40,
    viewBox: "0 0 82 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ellipse || (_ellipse = /*#__PURE__*/React.createElement("ellipse", {
    cx: 2.32799,
    cy: 38.6746,
    rx: 1.32165,
    ry: 1.94322,
    transform: "rotate(-90 2.32799 38.6746)",
    fill: "#E6E5E5"
  })), _ellipse2 || (_ellipse2 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 2.32799,
    cy: 33.388,
    rx: 1.32165,
    ry: 1.94322,
    transform: "rotate(-90 2.32799 33.388)",
    fill: "#E6E5E5"
  })), _ellipse3 || (_ellipse3 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 2.32799,
    cy: 28.1014,
    rx: 1.32165,
    ry: 1.94322,
    transform: "rotate(-90 2.32799 28.1014)",
    fill: "#E6E5E5"
  })), _ellipse4 || (_ellipse4 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 2.32799,
    cy: 22.8148,
    rx: 1.32165,
    ry: 1.94322,
    transform: "rotate(-90 2.32799 22.8148)",
    fill: "#E6E5E5"
  })), _ellipse5 || (_ellipse5 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 2.32799,
    cy: 17.5281,
    rx: 1.32165,
    ry: 1.94322,
    transform: "rotate(-90 2.32799 17.5281)",
    fill: "#E6E5E5"
  })), _ellipse6 || (_ellipse6 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 2.32799,
    cy: 12.2416,
    rx: 1.32165,
    ry: 1.94322,
    transform: "rotate(-90 2.32799 12.2416)",
    fill: "#E6E5E5"
  })), _ellipse7 || (_ellipse7 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 2.32799,
    cy: 6.95496,
    rx: 1.32165,
    ry: 1.94322,
    transform: "rotate(-90 2.32799 6.95496)",
    fill: "#E6E5E5"
  })), _ellipse8 || (_ellipse8 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 2.32799,
    cy: 1.66834,
    rx: 1.32165,
    ry: 1.94322,
    transform: "rotate(-90 2.32799 1.66834)",
    fill: "#E6E5E5"
  })), _ellipse9 || (_ellipse9 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 10.0995,
    cy: 38.6746,
    rx: 1.32165,
    ry: 1.94322,
    transform: "rotate(-90 10.0995 38.6746)",
    fill: "#E6E5E5"
  })), _ellipse10 || (_ellipse10 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 10.0995,
    cy: 33.388,
    rx: 1.32165,
    ry: 1.94322,
    transform: "rotate(-90 10.0995 33.388)",
    fill: "#E6E5E5"
  })), _ellipse11 || (_ellipse11 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 10.0995,
    cy: 28.1014,
    rx: 1.32165,
    ry: 1.94322,
    transform: "rotate(-90 10.0995 28.1014)",
    fill: "#E6E5E5"
  })), _ellipse12 || (_ellipse12 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 10.0995,
    cy: 22.8148,
    rx: 1.32165,
    ry: 1.94322,
    transform: "rotate(-90 10.0995 22.8148)",
    fill: "#E6E5E5"
  })), _ellipse13 || (_ellipse13 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 10.0995,
    cy: 17.5281,
    rx: 1.32165,
    ry: 1.94322,
    transform: "rotate(-90 10.0995 17.5281)",
    fill: "#E6E5E5"
  })), _ellipse14 || (_ellipse14 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 10.0995,
    cy: 12.2416,
    rx: 1.32165,
    ry: 1.94322,
    transform: "rotate(-90 10.0995 12.2416)",
    fill: "#E6E5E5"
  })), _ellipse15 || (_ellipse15 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 10.0995,
    cy: 6.95496,
    rx: 1.32165,
    ry: 1.94322,
    transform: "rotate(-90 10.0995 6.95496)",
    fill: "#E6E5E5"
  })), _ellipse16 || (_ellipse16 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 10.0995,
    cy: 1.66834,
    rx: 1.32165,
    ry: 1.94322,
    transform: "rotate(-90 10.0995 1.66834)",
    fill: "#E6E5E5"
  })), _ellipse17 || (_ellipse17 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 17.8749,
    cy: 38.6746,
    rx: 1.32165,
    ry: 1.94322,
    transform: "rotate(-90 17.8749 38.6746)",
    fill: "#E6E5E5"
  })), _ellipse18 || (_ellipse18 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 17.8749,
    cy: 33.388,
    rx: 1.32165,
    ry: 1.94322,
    transform: "rotate(-90 17.8749 33.388)",
    fill: "#E6E5E5"
  })), _ellipse19 || (_ellipse19 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 17.8749,
    cy: 28.1014,
    rx: 1.32165,
    ry: 1.94322,
    transform: "rotate(-90 17.8749 28.1014)",
    fill: "#E6E5E5"
  })), _ellipse20 || (_ellipse20 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 17.8749,
    cy: 22.8148,
    rx: 1.32165,
    ry: 1.94322,
    transform: "rotate(-90 17.8749 22.8148)",
    fill: "#E6E5E5"
  })), _ellipse21 || (_ellipse21 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 17.8749,
    cy: 17.5281,
    rx: 1.32165,
    ry: 1.94322,
    transform: "rotate(-90 17.8749 17.5281)",
    fill: "#E6E5E5"
  })), _ellipse22 || (_ellipse22 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 17.8749,
    cy: 12.2416,
    rx: 1.32165,
    ry: 1.94322,
    transform: "rotate(-90 17.8749 12.2416)",
    fill: "#E6E5E5"
  })), _ellipse23 || (_ellipse23 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 17.8749,
    cy: 6.95496,
    rx: 1.32165,
    ry: 1.94322,
    transform: "rotate(-90 17.8749 6.95496)",
    fill: "#E6E5E5"
  })), _ellipse24 || (_ellipse24 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 17.8749,
    cy: 1.66834,
    rx: 1.32165,
    ry: 1.94322,
    transform: "rotate(-90 17.8749 1.66834)",
    fill: "#E6E5E5"
  })), _ellipse25 || (_ellipse25 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 25.6463,
    cy: 38.6746,
    rx: 1.32165,
    ry: 1.94322,
    transform: "rotate(-90 25.6463 38.6746)",
    fill: "#E6E5E5"
  })), _ellipse26 || (_ellipse26 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 25.6463,
    cy: 33.388,
    rx: 1.32165,
    ry: 1.94322,
    transform: "rotate(-90 25.6463 33.388)",
    fill: "#E6E5E5"
  })), _ellipse27 || (_ellipse27 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 25.6463,
    cy: 28.1014,
    rx: 1.32165,
    ry: 1.94322,
    transform: "rotate(-90 25.6463 28.1014)",
    fill: "#E6E5E5"
  })), _ellipse28 || (_ellipse28 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 25.6463,
    cy: 22.8148,
    rx: 1.32165,
    ry: 1.94322,
    transform: "rotate(-90 25.6463 22.8148)",
    fill: "#E6E5E5"
  })), _ellipse29 || (_ellipse29 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 25.6463,
    cy: 17.5281,
    rx: 1.32165,
    ry: 1.94322,
    transform: "rotate(-90 25.6463 17.5281)",
    fill: "#E6E5E5"
  })), _ellipse30 || (_ellipse30 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 25.6463,
    cy: 12.2416,
    rx: 1.32165,
    ry: 1.94322,
    transform: "rotate(-90 25.6463 12.2416)",
    fill: "#E6E5E5"
  })), _ellipse31 || (_ellipse31 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 25.6463,
    cy: 6.95496,
    rx: 1.32165,
    ry: 1.94322,
    transform: "rotate(-90 25.6463 6.95496)",
    fill: "#E6E5E5"
  })), _ellipse32 || (_ellipse32 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 25.6463,
    cy: 1.66834,
    rx: 1.32165,
    ry: 1.94322,
    transform: "rotate(-90 25.6463 1.66834)",
    fill: "#E6E5E5"
  })), _ellipse33 || (_ellipse33 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 33.4198,
    cy: 38.6746,
    rx: 1.32165,
    ry: 1.94322,
    transform: "rotate(-90 33.4198 38.6746)",
    fill: "#E6E5E5"
  })), _ellipse34 || (_ellipse34 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 33.4198,
    cy: 33.388,
    rx: 1.32165,
    ry: 1.94322,
    transform: "rotate(-90 33.4198 33.388)",
    fill: "#E6E5E5"
  })), _ellipse35 || (_ellipse35 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 33.4198,
    cy: 28.1014,
    rx: 1.32165,
    ry: 1.94322,
    transform: "rotate(-90 33.4198 28.1014)",
    fill: "#E6E5E5"
  })), _ellipse36 || (_ellipse36 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 33.4198,
    cy: 22.8148,
    rx: 1.32165,
    ry: 1.94322,
    transform: "rotate(-90 33.4198 22.8148)",
    fill: "#E6E5E5"
  })), _ellipse37 || (_ellipse37 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 33.4198,
    cy: 17.5281,
    rx: 1.32165,
    ry: 1.94322,
    transform: "rotate(-90 33.4198 17.5281)",
    fill: "#E6E5E5"
  })), _ellipse38 || (_ellipse38 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 33.4198,
    cy: 12.2416,
    rx: 1.32165,
    ry: 1.94322,
    transform: "rotate(-90 33.4198 12.2416)",
    fill: "#E6E5E5"
  })), _ellipse39 || (_ellipse39 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 33.4198,
    cy: 6.95496,
    rx: 1.32165,
    ry: 1.94322,
    transform: "rotate(-90 33.4198 6.95496)",
    fill: "#E6E5E5"
  })), _ellipse40 || (_ellipse40 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 33.4198,
    cy: 1.66834,
    rx: 1.32165,
    ry: 1.94322,
    transform: "rotate(-90 33.4198 1.66834)",
    fill: "#E6E5E5"
  })), _ellipse41 || (_ellipse41 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 48.9667,
    cy: 38.6746,
    rx: 1.32165,
    ry: 1.94322,
    transform: "rotate(-90 48.9667 38.6746)",
    fill: "#E6E5E5"
  })), _ellipse42 || (_ellipse42 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 48.9667,
    cy: 33.388,
    rx: 1.32165,
    ry: 1.94322,
    transform: "rotate(-90 48.9667 33.388)",
    fill: "#E6E5E5"
  })), _ellipse43 || (_ellipse43 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 48.9667,
    cy: 28.1014,
    rx: 1.32165,
    ry: 1.94322,
    transform: "rotate(-90 48.9667 28.1014)",
    fill: "#E6E5E5"
  })), _ellipse44 || (_ellipse44 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 48.9667,
    cy: 22.8148,
    rx: 1.32165,
    ry: 1.94322,
    transform: "rotate(-90 48.9667 22.8148)",
    fill: "#E6E5E5"
  })), _ellipse45 || (_ellipse45 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 48.9667,
    cy: 17.5281,
    rx: 1.32165,
    ry: 1.94322,
    transform: "rotate(-90 48.9667 17.5281)",
    fill: "#E6E5E5"
  })), _ellipse46 || (_ellipse46 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 48.9667,
    cy: 12.2416,
    rx: 1.32165,
    ry: 1.94322,
    transform: "rotate(-90 48.9667 12.2416)",
    fill: "#E6E5E5"
  })), _ellipse47 || (_ellipse47 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 48.9667,
    cy: 6.95496,
    rx: 1.32165,
    ry: 1.94322,
    transform: "rotate(-90 48.9667 6.95496)",
    fill: "#E6E5E5"
  })), _ellipse48 || (_ellipse48 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 48.9667,
    cy: 1.66834,
    rx: 1.32165,
    ry: 1.94322,
    transform: "rotate(-90 48.9667 1.66834)",
    fill: "#E6E5E5"
  })), _ellipse49 || (_ellipse49 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 56.7381,
    cy: 38.6746,
    rx: 1.32165,
    ry: 1.94322,
    transform: "rotate(-90 56.7381 38.6746)",
    fill: "#E6E5E5"
  })), _ellipse50 || (_ellipse50 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 56.7381,
    cy: 33.388,
    rx: 1.32165,
    ry: 1.94322,
    transform: "rotate(-90 56.7381 33.388)",
    fill: "#E6E5E5"
  })), _ellipse51 || (_ellipse51 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 56.7381,
    cy: 28.1014,
    rx: 1.32165,
    ry: 1.94322,
    transform: "rotate(-90 56.7381 28.1014)",
    fill: "#E6E5E5"
  })), _ellipse52 || (_ellipse52 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 56.7381,
    cy: 22.8148,
    rx: 1.32165,
    ry: 1.94322,
    transform: "rotate(-90 56.7381 22.8148)",
    fill: "#E6E5E5"
  })), _ellipse53 || (_ellipse53 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 56.7381,
    cy: 17.5281,
    rx: 1.32165,
    ry: 1.94322,
    transform: "rotate(-90 56.7381 17.5281)",
    fill: "#E6E5E5"
  })), _ellipse54 || (_ellipse54 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 56.7381,
    cy: 12.2416,
    rx: 1.32165,
    ry: 1.94322,
    transform: "rotate(-90 56.7381 12.2416)",
    fill: "#E6E5E5"
  })), _ellipse55 || (_ellipse55 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 56.7381,
    cy: 6.95496,
    rx: 1.32165,
    ry: 1.94322,
    transform: "rotate(-90 56.7381 6.95496)",
    fill: "#E6E5E5"
  })), _ellipse56 || (_ellipse56 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 56.7381,
    cy: 1.66834,
    rx: 1.32165,
    ry: 1.94322,
    transform: "rotate(-90 56.7381 1.66834)",
    fill: "#E6E5E5"
  })), _ellipse57 || (_ellipse57 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 64.5096,
    cy: 38.6746,
    rx: 1.32165,
    ry: 1.94322,
    transform: "rotate(-90 64.5096 38.6746)",
    fill: "#E6E5E5"
  })), _ellipse58 || (_ellipse58 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 64.5096,
    cy: 33.388,
    rx: 1.32165,
    ry: 1.94322,
    transform: "rotate(-90 64.5096 33.388)",
    fill: "#E6E5E5"
  })), _ellipse59 || (_ellipse59 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 64.5096,
    cy: 28.1014,
    rx: 1.32165,
    ry: 1.94322,
    transform: "rotate(-90 64.5096 28.1014)",
    fill: "#E6E5E5"
  })), _ellipse60 || (_ellipse60 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 64.5096,
    cy: 22.8148,
    rx: 1.32165,
    ry: 1.94322,
    transform: "rotate(-90 64.5096 22.8148)",
    fill: "#E6E5E5"
  })), _ellipse61 || (_ellipse61 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 64.5096,
    cy: 17.5281,
    rx: 1.32165,
    ry: 1.94322,
    transform: "rotate(-90 64.5096 17.5281)",
    fill: "#E6E5E5"
  })), _ellipse62 || (_ellipse62 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 64.5096,
    cy: 12.2416,
    rx: 1.32165,
    ry: 1.94322,
    transform: "rotate(-90 64.5096 12.2416)",
    fill: "#E6E5E5"
  })), _ellipse63 || (_ellipse63 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 64.5096,
    cy: 6.95496,
    rx: 1.32165,
    ry: 1.94322,
    transform: "rotate(-90 64.5096 6.95496)",
    fill: "#E6E5E5"
  })), _ellipse64 || (_ellipse64 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 64.5096,
    cy: 1.66834,
    rx: 1.32165,
    ry: 1.94322,
    transform: "rotate(-90 64.5096 1.66834)",
    fill: "#E6E5E5"
  })), _ellipse65 || (_ellipse65 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 72.285,
    cy: 38.6746,
    rx: 1.32165,
    ry: 1.94322,
    transform: "rotate(-90 72.285 38.6746)",
    fill: "#E6E5E5"
  })), _ellipse66 || (_ellipse66 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 72.285,
    cy: 33.388,
    rx: 1.32165,
    ry: 1.94322,
    transform: "rotate(-90 72.285 33.388)",
    fill: "#E6E5E5"
  })), _ellipse67 || (_ellipse67 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 72.285,
    cy: 28.1014,
    rx: 1.32165,
    ry: 1.94322,
    transform: "rotate(-90 72.285 28.1014)",
    fill: "#E6E5E5"
  })), _ellipse68 || (_ellipse68 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 72.285,
    cy: 22.8148,
    rx: 1.32165,
    ry: 1.94322,
    transform: "rotate(-90 72.285 22.8148)",
    fill: "#E6E5E5"
  })), _ellipse69 || (_ellipse69 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 72.285,
    cy: 17.5281,
    rx: 1.32165,
    ry: 1.94322,
    transform: "rotate(-90 72.285 17.5281)",
    fill: "#E6E5E5"
  })), _ellipse70 || (_ellipse70 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 72.285,
    cy: 12.2416,
    rx: 1.32165,
    ry: 1.94322,
    transform: "rotate(-90 72.285 12.2416)",
    fill: "#E6E5E5"
  })), _ellipse71 || (_ellipse71 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 72.285,
    cy: 6.95496,
    rx: 1.32165,
    ry: 1.94322,
    transform: "rotate(-90 72.285 6.95496)",
    fill: "#E6E5E5"
  })), _ellipse72 || (_ellipse72 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 72.285,
    cy: 1.66834,
    rx: 1.32165,
    ry: 1.94322,
    transform: "rotate(-90 72.285 1.66834)",
    fill: "#E6E5E5"
  })), _ellipse73 || (_ellipse73 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 80.0565,
    cy: 38.6746,
    rx: 1.32165,
    ry: 1.94322,
    transform: "rotate(-90 80.0565 38.6746)",
    fill: "#E6E5E5"
  })), _ellipse74 || (_ellipse74 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 80.0565,
    cy: 33.388,
    rx: 1.32165,
    ry: 1.94322,
    transform: "rotate(-90 80.0565 33.388)",
    fill: "#E6E5E5"
  })), _ellipse75 || (_ellipse75 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 80.0565,
    cy: 28.1014,
    rx: 1.32165,
    ry: 1.94322,
    transform: "rotate(-90 80.0565 28.1014)",
    fill: "#E6E5E5"
  })), _ellipse76 || (_ellipse76 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 80.0565,
    cy: 22.8148,
    rx: 1.32165,
    ry: 1.94322,
    transform: "rotate(-90 80.0565 22.8148)",
    fill: "#E6E5E5"
  })), _ellipse77 || (_ellipse77 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 80.0565,
    cy: 17.5281,
    rx: 1.32165,
    ry: 1.94322,
    transform: "rotate(-90 80.0565 17.5281)",
    fill: "#E6E5E5"
  })), _ellipse78 || (_ellipse78 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 80.0565,
    cy: 12.2416,
    rx: 1.32165,
    ry: 1.94322,
    transform: "rotate(-90 80.0565 12.2416)",
    fill: "#E6E5E5"
  })), _ellipse79 || (_ellipse79 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 80.0565,
    cy: 6.95496,
    rx: 1.32165,
    ry: 1.94322,
    transform: "rotate(-90 80.0565 6.95496)",
    fill: "#E6E5E5"
  })), _ellipse80 || (_ellipse80 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 80.0565,
    cy: 1.66834,
    rx: 1.32165,
    ry: 1.94322,
    transform: "rotate(-90 80.0565 1.66834)",
    fill: "#E6E5E5"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDotsRightDown);
export default __webpack_public_path__ + "static/media/dots-right-down.ce0d6e7546a8981f6031b6a5c936b97e.svg";
export { ForwardRef as ReactComponent };